export default __webpack_public_path__ + "static/media/Head_5_Ear_2_C3.684fb1af.svg";